import moment from 'moment'

export const formatDate = date => {
	return date ? moment(date).format("DD MMMM YYYY") : null;
};



// WEBPACK FOOTER //
// ./src/utils/notification/index.js